import * as React from "react";
import { connect } from "react-redux";
import { values } from "lodash";

import { OldProgressBarQuestionnaireSectionUnconnected } from "@teamprevent/common/questionnaires/components/OldProgressBarQuestionnaireSection";
import { getQuestionConfig } from "@teamprevent/common/questionnaires/questionnaireConfig";
import { YesNoWithFollowUpQuestion } from "@teamprevent/common/questionnaires/components/questions/YesNoWithFollowUpQuestion";
import { getAnswerToQuestionWithId } from "@teamprevent/common/questionnaires/getAnswerToQuestionWithId";
import { TextQuestion } from "@teamprevent/common/questionnaires/components/questions/TextQuestion";
import { MultiButtonQuestion } from "@teamprevent/common/questionnaires/components/questions/MultiButtonQuestion";
import { makeMapStateToQuestionnaireSectionProps, mapDispatchToQuestionnaireSectionProps } from "@teamprevent/common/questionnaires/mappers";

import * as questionIds from "../questions/questionIds";
import { HealthSurveillanceSectionProps, SupportingDocumentsProps } from "../models";
import { acceptableExtensions } from "../../acceptableExtensions";
import { FilesQuestion } from "../../questionnaires/components/questions/FilesQuestion";
import { sections } from "../questionnaire";

type Props = HealthSurveillanceSectionProps & SupportingDocumentsProps & { hide?: boolean};

// eslint-disable-next-line max-len
const HealthSurveillanceMedicalQuestionsSectionTwoUnconnected: React.FunctionComponent<Props> = (props: Props) => {

    const questions = values(props.questions || {});
    const containsOnlySupportingDocumentsQuestion = questions?.length === 1 && questions[0]?.id === questionIds.SupportingDocuments;

    return (
        <OldProgressBarQuestionnaireSectionUnconnected
            {...props}
            {...sections.MedicalQuestions2}
        >
            {!containsOnlySupportingDocumentsQuestion &&
                <h4>Have you ever suffered from or are you currently suffering from any of the following medical conditions or medical problems</h4>
            }
            {YesNoWithFollowUpQuestion({
                questionConfigs: [
                    getQuestionConfig(props.questionConfigs, questionIds.HeartProblems),
                    getQuestionConfig(props.questionConfigs, questionIds.HeartProblemsFurtherDetails)
                ],
                readonly: props.readonly,
                questions: props.questions
            })}
            {YesNoWithFollowUpQuestion({
                questionConfigs: [
                    getQuestionConfig(props.questionConfigs, questionIds.HighBloodPressure),
                    getQuestionConfig(props.questionConfigs, questionIds.HighBloodPressureFurtherDetails)
                ],
                readonly: props.readonly,
                questions: props.questions
            })}
            {YesNoWithFollowUpQuestion({
                questionConfigs: [
                    getQuestionConfig(props.questionConfigs, questionIds.StokeOrTransientIschaemicAttacks),
                    getQuestionConfig(props.questionConfigs, questionIds.StokeOrTransientIschaemicAttacksFurtherDetails)
                ],
                readonly: props.readonly,
                questions: props.questions
            })}
            {YesNoWithFollowUpQuestion({
                questionConfigs: [
                    getQuestionConfig(props.questionConfigs, questionIds.HeadInjuryRequiringHospital),
                    getQuestionConfig(props.questionConfigs, questionIds.HeadInjuryRequiringHospitalFurtherDetails)
                ],
                readonly: props.readonly,
                questions: props.questions
            })}
            {YesNoWithFollowUpQuestion({
                questionConfigs: [
                    getQuestionConfig(props.questionConfigs, questionIds.RespiratoryDisease),
                    getQuestionConfig(props.questionConfigs, questionIds.RespiratoryDiseaseFurtherDetails)
                ],
                readonly: props.readonly,
                questions: props.questions
            })}
            {YesNoWithFollowUpQuestion({
                questionConfigs: [
                    getQuestionConfig(props.questionConfigs, questionIds.PeripheralVascularDisease),
                    getQuestionConfig(props.questionConfigs, questionIds.PeripheralVascularDiseaseFurtherDetails)
                ],
                readonly: props.readonly,
                questions: props.questions
            })}
            {YesNoWithFollowUpQuestion({
                questionConfigs: [
                    getQuestionConfig(props.questionConfigs, questionIds.BloodCoagulationDisorders),
                    getQuestionConfig(props.questionConfigs, questionIds.BloodCoagulationDisordersFurtherDetails)
                ],
                readonly: props.readonly,
                questions: props.questions
            })}
            {YesNoWithFollowUpQuestion({
                questionConfigs: [
                    getQuestionConfig(props.questionConfigs, questionIds.MetabolicDisorders),
                    getQuestionConfig(props.questionConfigs, questionIds.MetabolicDisordersFurtherDetails)
                ],
                readonly: props.readonly,
                questions: props.questions
            })}
            {YesNoWithFollowUpQuestion({
                questionConfigs: [
                    getQuestionConfig(props.questionConfigs, questionIds.GastricIntestinalProblems),
                    getQuestionConfig(props.questionConfigs, questionIds.GastricIntestinalProblemsFurtherDetails)
                ],
                readonly: props.readonly,
                questions: props.questions
            })}
            {YesNoWithFollowUpQuestion({
                questionConfigs: [
                    getQuestionConfig(props.questionConfigs, questionIds.HistoryOfBlackouts),
                    getQuestionConfig(props.questionConfigs, questionIds.HistoryOfBlackoutsFurtherDetails)
                ],
                readonly: props.readonly,
                questions: props.questions
            })}
            {YesNoWithFollowUpQuestion({
                questionConfigs: [
                    getQuestionConfig(props.questionConfigs, questionIds.SleepDisorders),
                    getQuestionConfig(props.questionConfigs, questionIds.SleepDisordersFurtherDetails)
                ],
                readonly: props.readonly,
                questions: props.questions
            })}
            {YesNoWithFollowUpQuestion({
                questionConfigs: [
                    getQuestionConfig(props.questionConfigs, questionIds.MusculoskeltalDisorders),
                    getQuestionConfig(props.questionConfigs, questionIds.MusculoskeltalDisordersFurtherDetails)
                ],
                readonly: props.readonly,
                questions: props.questions
            })}
            {YesNoWithFollowUpQuestion({
                questionConfigs: [
                    getQuestionConfig(props.questionConfigs, questionIds.JointProblems),
                    getQuestionConfig(props.questionConfigs, questionIds.JointProblemsFurtherDetails)
                ],
                readonly: props.readonly,
                questions: props.questions
            })}
            {YesNoWithFollowUpQuestion({
                questionConfigs: [
                    getQuestionConfig(props.questionConfigs, questionIds.NeurologicalDisorders),
                    getQuestionConfig(props.questionConfigs, questionIds.NeurologicalDisordersFurtherDetails)
                ],
                readonly: props.readonly,
                questions: props.questions
            })}
            {getAnswerToQuestionWithId(questions, questionIds.NeurologicalDisorders) === MultiButtonQuestion.YesOption &&
                <>
                    { /* eslint-disable max-len */}
                    <MultiButtonQuestion questionConfig={getQuestionConfig(props.questionConfigs, questionIds.NeurologicalDisordersMedication)} readonly={props.readonly} />
                    <TextQuestion questionConfig={getQuestionConfig(props.questionConfigs, questionIds.NeurologicalDisordersLastEpisode)} readonly={props.readonly} />
                    <MultiButtonQuestion questionConfig={getQuestionConfig(props.questionConfigs, questionIds.ConditionsThatAffectBalance)} readonly={props.readonly} />
                    { /* eslint-enable max-len */}
                </>}
            {YesNoWithFollowUpQuestion({
                questionConfigs: [
                    getQuestionConfig(props.questionConfigs, questionIds.Headaches),
                    getQuestionConfig(props.questionConfigs, questionIds.HeadachesFurtherDetails)
                ],
                readonly: props.readonly,
                questions: props.questions
            })}
            {YesNoWithFollowUpQuestion({
                questionConfigs: [
                    getQuestionConfig(props.questionConfigs, questionIds.HearingDifficulty),
                    getQuestionConfig(props.questionConfigs, questionIds.HearingDifficultyFurtherDetails)
                ],
                readonly: props.readonly,
                questions: props.questions
            })}
            {YesNoWithFollowUpQuestion({
                questionConfigs: [
                    getQuestionConfig(props.questionConfigs, questionIds.DifficultyWithVision),
                    getQuestionConfig(props.questionConfigs, questionIds.DifficultyWithVisionFurtherDetails)
                ],
                readonly: props.readonly,
                questions: props.questions
            })}
            {YesNoWithFollowUpQuestion({
                questionConfigs: [
                    getQuestionConfig(props.questionConfigs, questionIds.Claustophobia),
                    getQuestionConfig(props.questionConfigs, questionIds.ClaustophobiaFurtherDetails)
                ],
                readonly: props.readonly,
                questions: props.questions
            })}
            {YesNoWithFollowUpQuestion({
                questionConfigs: [
                    getQuestionConfig(props.questionConfigs, questionIds.SkinDisorders),
                    getQuestionConfig(props.questionConfigs, questionIds.SkinDisordersFurtherDetails)
                ],
                readonly: props.readonly,
                questions: props.questions
            })}
            {YesNoWithFollowUpQuestion({
                questionConfigs: [
                    getQuestionConfig(props.questionConfigs, questionIds.LackSenseOfSmell),
                    getQuestionConfig(props.questionConfigs, questionIds.LackSenseOfSmellFurtherDetails)
                ],
                readonly: props.readonly,
                questions: props.questions
            })}
            {YesNoWithFollowUpQuestion({
                questionConfigs: [
                    getQuestionConfig(props.questionConfigs, questionIds.FearHeights),
                    getQuestionConfig(props.questionConfigs, questionIds.FearHeightsFurtherDetails)
                ],
                readonly: props.readonly,
                questions: props.questions
            })}
            {YesNoWithFollowUpQuestion({
                questionConfigs: [
                    getQuestionConfig(props.questionConfigs, questionIds.UnderlyingMentalHealthConditions),
                    getQuestionConfig(props.questionConfigs, questionIds.UnderlyingMentalHealthConditionsFurtherDetails)
                ],
                readonly: props.readonly,
                questions: props.questions
            })}
            {YesNoWithFollowUpQuestion({
                questionConfigs: [
                    getQuestionConfig(props.questionConfigs, questionIds.ImpairedAwareness),
                    getQuestionConfig(props.questionConfigs, questionIds.ImpairedAwarenessFurtherDetails)
                ],
                readonly: props.readonly,
                questions: props.questions
            })}
            {YesNoWithFollowUpQuestion({
                questionConfigs: [
                    getQuestionConfig(props.questionConfigs, questionIds.StrictMedicationTimetable),
                    getQuestionConfig(props.questionConfigs, questionIds.StrictMedicationTimetableFurtherDetails)
                ],
                readonly: props.readonly,
                questions: props.questions
            })}
            {YesNoWithFollowUpQuestion({
                questionConfigs: [
                    getQuestionConfig(props.questionConfigs, questionIds.MedicationSideEffects),
                    getQuestionConfig(props.questionConfigs, questionIds.MedicationSideEffectsFurtherDetails)
                ],
                readonly: props.readonly,
                questions: props.questions
            })}
            {YesNoWithFollowUpQuestion({
                questionConfigs: [
                    getQuestionConfig(props.questionConfigs, questionIds.AlcoholDependency),
                    getQuestionConfig(props.questionConfigs, questionIds.AlcoholDependencyFurtherDetails)
                ],
                readonly: props.readonly,
                questions: props.questions
            })}
            {YesNoWithFollowUpQuestion({
                questionConfigs: [
                    getQuestionConfig(props.questionConfigs, questionIds.DrugDependency),
                    getQuestionConfig(props.questionConfigs, questionIds.DrugDependencyFurtherDetails)
                ],
                readonly: props.readonly,
                questions: props.questions
            })}
            {YesNoWithFollowUpQuestion({
                questionConfigs: [
                    getQuestionConfig(props.questionConfigs, questionIds.NonPrescribedDrugs),
                    getQuestionConfig(props.questionConfigs, questionIds.NonPrescribedDrugsFurtherDetails)
                ],
                readonly: props.readonly,
                questions: props.questions
            })}
            {YesNoWithFollowUpQuestion({
                questionConfigs: [
                    getQuestionConfig(props.questionConfigs, questionIds.MoreThan14UnitsAlcoholAWeek),
                    getQuestionConfig(props.questionConfigs, questionIds.MoreThan14UnitsAlcoholAWeekFurtherDetails)
                ],
                readonly: props.readonly,
                questions: props.questions
            })}
            {YesNoWithFollowUpQuestion({
                questionConfigs: [
                    getQuestionConfig(props.questionConfigs, questionIds.RetiredIllHealth),
                    getQuestionConfig(props.questionConfigs, questionIds.RetiredIllHealthFurtherDetails)
                ],
                readonly: props.readonly,
                questions: props.questions
            })}
            {YesNoWithFollowUpQuestion({
                questionConfigs: [
                    getQuestionConfig(props.questionConfigs, questionIds.NotifyDvlaMedicalConditions),
                    getQuestionConfig(props.questionConfigs, questionIds.NotifyDvlaMedicalConditionsFurtherDetails)
                ],
                readonly: props.readonly,
                questions: props.questions
            })}
            {YesNoWithFollowUpQuestion({
                questionConfigs: [
                    getQuestionConfig(props.questionConfigs, questionIds.WearGlasses),
                    getQuestionConfig(props.questionConfigs, questionIds.WearGlassesFurtherDetails)
                ],
                readonly: props.readonly,
                questions: props.questions
            })}
            {YesNoWithFollowUpQuestion({
                questionConfigs: [
                    getQuestionConfig(props.questionConfigs, questionIds.WearContactLenses),
                    getQuestionConfig(props.questionConfigs, questionIds.WearContactLensesFurtherDetails)
                ],
                readonly: props.readonly,
                questions: props.questions
            })}
            {YesNoWithFollowUpQuestion({
                questionConfigs: [
                    getQuestionConfig(props.questionConfigs, questionIds.ExaminedByVisionSpecialistOptician),
                    getQuestionConfig(props.questionConfigs, questionIds.ExaminedByVisionSpecialistOpticianFurtherDetails)
                ],
                readonly: props.readonly,
                questions: props.questions
            })}
            {YesNoWithFollowUpQuestion({
                questionConfigs: [
                    getQuestionConfig(props.questionConfigs, questionIds.DifficultiesWithEyes),
                    getQuestionConfig(props.questionConfigs, questionIds.DifficultiesWithEyesFurtherDetails)
                ],
                readonly: props.readonly,
                questions: props.questions
            })}
            {YesNoWithFollowUpQuestion({
                questionConfigs: [
                    getQuestionConfig(props.questionConfigs, questionIds.ColourBlind),
                    getQuestionConfig(props.questionConfigs, questionIds.ColourBlindFurtherDetails)
                ],
                readonly: props.readonly,
                questions: props.questions
            })}
            <FilesQuestion
                api={props.fileUploadApi}
                onUpload={props.onFileUpload}
                readonly={props.readonly}
                questionConfig={getQuestionConfig(props.questionConfigs, questionIds.SupportingDocuments)}
                getDownloadLink={props.getDownloadLink}
                onDeleteFile={props.onDeleteFile}
                acceptExtensions={acceptableExtensions}
                outdated={{
                    isOutdated: false,
                    questionnaireKey: props.questionnaireKey,
                    sectionId: sections.MedicalQuestions2.id
                }}
            />
        </OldProgressBarQuestionnaireSectionUnconnected>
    );
};

// eslint-disable-next-line max-len
export const HealthSurveillanceMedicalQuestionsSectionTwo = connect(makeMapStateToQuestionnaireSectionProps(sections.MedicalQuestions2.id), mapDispatchToQuestionnaireSectionProps)(HealthSurveillanceMedicalQuestionsSectionTwoUnconnected);
